<template>
    <path fill-rule="evenodd"
          d="M13 0c-2.842 0-5.3 1.12-6.83 2.941C4.64 4.761 4 7.121 4 9.663V11h3.857V9.663c0-1.93.5-3.448 1.326-4.43.826-.983 1.941-1.566 3.817-1.566 1.88 0 2.993.55 3.817 1.527.824.977 1.326 2.519 1.326 4.47V11H22V9.663c0-2.557-.677-4.942-2.21-6.76C18.257 1.085 15.837 0 13 0zM3.75 12C1.68 12 0 13.68 0 15.75v12.5C0 30.32 1.68 32 3.75 32h17.5c2.07 0 3.75-1.68 3.75-3.75v-12.5c0-2.07-1.68-3.75-3.75-3.75H3.75zm8.75 6c1.38 0 2.5 1.152 2.5 2.571 0 .95-.505 1.764-1.25 2.21v2.933c0 .709-.561 1.286-1.25 1.286s-1.25-.577-1.25-1.286v-2.933a2.564 2.564 0 0 1-1.25-2.21C10 19.152 11.12 18 12.5 18z"/>
</template>

<script>
export default {
    name: 'lockIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 25 32');
    }
};
</script>
